import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Services from "./sections/Services";
import Capability from "./sections/Capability";
import Contractors from "./sections/Contractors";
import Residential from "./sections/Residential";
import Accreditations from "./sections/Accreditations";
import Gallery from "./sections/Gallery";
import Why from "./sections/Why";
import Coverage from "./sections/Coverage";
import Story from "./sections/Story";
import Cta from "./sections/Cta";
import Reviews from "./sections/Reviews";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <Services />
      <Capability />
      <Contractors />
      <Residential />
      <Accreditations />
      <Gallery />
      <Why />
      <Coverage />
      <Story />
      <Reviews />
      <Cta />
      <Footer />
    </div>;
}